import styled from "styled-components";

import Input from "ds/Input";

export const IntervalNumInput = styled(Input)`
  & > input {
    height: 40px;
  }
`;
